import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { EmailSettingsView } from "@/components/EmailSettingsView";

const EmailSettings = () => {
  const navigate = useNavigate();
  const { slug } = useParams();

  const handleBack = () => {
    if (slug) {
      navigate(`/${slug}/dashboard`);
    } else {
      navigate('/dashboard');
    }
  };

  return (
    <div className="min-h-screen bg-muted/30">
      <header className="bg-card border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center gap-4">
            <Button variant="ghost" size="icon" onClick={handleBack}>
              <ArrowLeft className="w-5 h-5" />
            </Button>
            <div>
              <h1 className="text-xl md:text-2xl font-serif font-bold">
                Paramètres des emails
              </h1>
              <p className="text-sm text-muted-foreground">
                Configurez les templates d'emails envoyés à vos clients
              </p>
            </div>
          </div>
        </div>
      </header>

      <div className="container mx-auto px-4 py-6">
        <EmailSettingsView />
      </div>
    </div>
  );
};

export default EmailSettings;
